import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import moment from "moment";
import SelectField from "../Shared/SelectField";
import TextInputField from "../Shared/TextInputField";
import Textarea from "components/Shared/Textarea";
import { TASK_STATUS } from "./constant";

const TodoForm = ({ isSubmitting, todo, assignees, onSubmit, onReset }) => {
  const [assignedTo, setAssignedTo] = useState("");
  const [urgency, setUrgency] = useState(1);
  const [status, setStatus] = useState(TASK_STATUS.UNCOMPLETED);
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState(moment().format("YYYY-MM-DD"));

  const userId = useSelector((state) => state.app.userId);

  useEffect(() => {
    if (todo) {
      setAssignedTo(get(todo, "assigned_to", ""));
      setUrgency(get(todo, "urgency", ""));
      setStatus(get(todo, "status", ""));
      setDescription(get(todo, "description", ""));
      setDueDate(get(todo, "due_date", ""));
    }
  }, [todo]);

  const handleClickReset = () => {
    setAssignedTo("");
    setUrgency("");
    setStatus("");
    setDescription("");
    setDueDate("");
    onReset();
  };

  const handleClickSubmit = async () => {
    onSubmit({
      assigned_to: assignedTo,
      urgency,
      status,
      description,
      due_date: dueDate,
      created_by: userId,
    });
  };

  return (
    <div>
      <div className="columns">
        <div className="column is-one-fifth">
          <div className="mb-2">
            <SelectField
              isRequired={true}
              hasError={!assignedTo}
              label="Assigned To"
              value={assignedTo}
              options={assignees.map((o) => ({
                label: `${o.firstName} ${o.lastName}`,
                value: o.uid,
              }))}
              onChange={(e) => setAssignedTo(e.target.value)}
            />
          </div>
          <div>
            <SelectField
              isRequired={true}
              hasError={!urgency}
              label="Urgency"
              value={urgency}
              options={[
                { label: "High", value: 1 },
                { label: "Medium", value: 2 },
                { label: "Low", value: 3 },
              ]}
              onChange={(e) => setUrgency(e.target.value)}
            />
          </div>
        </div>
        <div className="column is-one-fifth">
          <div className="mb-2">
            <SelectField
              isRequired={true}
              hasError={!status}
              label="Status"
              value={status}
              options={[
                { label: "Completed", value: TASK_STATUS.COMPLETED },
                { label: "Uncompleted", value: TASK_STATUS.UNCOMPLETED },
              ]}
              onChange={(e) => setStatus(e.target.value)}
            />
          </div>
          <div>
            <TextInputField
              label="Due Date"
              value={dueDate}
              isRequired={true}
              hasError={!dueDate}
              type="date"
              onChange={(e) => {
                setDueDate(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="column is-two-fifths">
          <Textarea
            label="Description"
            value={description}
            isRequired={true}
            rows={2}
            onChange={(e) => setDescription(e.target.value)}
          />
          <div className="field is-grouped">
            <p className="control">
              <button
                className={`${isSubmitting ? "is-loading " : ""}button is-info is-small is-radiusless`}
                onClick={handleClickSubmit}
                disabled={!assignedTo || !status || !urgency || !dueDate || !description || isSubmitting}
              >
                {todo ? "Update" : "Create"}
              </button>
            </p>
            <p className="control">
              <button className="button is-info-light is-small is-radiusless" onClick={handleClickReset}>
                Reset
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodoForm;
